
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail } from "lucide-react";

interface EmailFieldProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  placeholder: string;
  isDisabled?: boolean;
}

export const EmailField = ({ 
  value, 
  onChange, 
  label, 
  placeholder,
  isDisabled = false 
}: EmailFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="email" className="text-sm font-medium flex items-center gap-2">
        <Mail className="h-4 w-4 text-primary" />
        {label}
      </Label>
      <Input
        id="email"
        type="email"
        value={value}
        onChange={onChange}
        required
        placeholder={placeholder}
        className="border-input shadow-sm focus:border-primary/30 focus:ring-primary/20"
        disabled={isDisabled}
      />
    </div>
  );
};
